"use client";

import { Link, usePathname } from "@/i18n/navigation";
import { useAuthModal } from "@/hooks/auth/useAuthModal";
import { cn } from "@/lib/utils";
import { getBottomNavbarItems } from "./bottomNavbarItems";
import { User } from "@/types/auth";

type BottomNavBarProps = {
  user: User | null;
};

const BottomNavBar = ({ user }: BottomNavBarProps) => {
  const pathname = usePathname();
  const { isOpen, openLogin } = useAuthModal();
  const items = getBottomNavbarItems(user);

  return (
    <>
      {true ? (
        <nav className="fixed inset-x-0 bottom-0 z-40 bg-white/90 backdrop-blur-sm md:hidden shadow-2xl h-[70px]">
          <div
            className={cn(
              "grid h-16 py-2 px-4",
              user ? "grid-cols-4" : "grid-cols-3",
            )}
          >
            {items.map(({ label, href, Icon, match, isLoginTrigger }) => {
              const isActive = isLoginTrigger
                ? isOpen
                : match
                  ? match(pathname)
                  : pathname === href;

              const content = (
                <>
                  <span
                    className={cn(
                      "flex items-center justify-center transition-colors hover:text-[rgba(11,155,255,1)]",
                      isActive
                        ? "text-[rgba(11,155,255,1)]"
                        : "text-[rgba(28,30,33,1)]",
                    )}
                  >
                    <Icon className="size-6" stroke={1.8} />
                  </span>
                  <span
                    className={cn(
                      "text-[12px] font-medium leading-4 hover:text-[rgba(11,155,255,1)]",
                      isActive
                        ? "text-[rgba(11,155,255,1)]"
                        : "text-[rgba(28,30,33,1)]",
                    )}
                  >
                    {label}
                  </span>
                </>
              );

              if (isLoginTrigger) {
                return (
                  <button
                    key={label}
                    type="button"
                    onClick={() => {
                      void openLogin("email");
                    }}
                    className="flex h-full flex-col items-center justify-center gap-1 px-2"
                    aria-current={isActive ? "page" : undefined}
                  >
                    {content}
                  </button>
                );
              }

              return (
                <Link
                  key={label}
                  href={href}
                  className="flex h-full flex-col items-center justify-center gap-1 px-2"
                  aria-current={isActive ? "page" : undefined}
                >
                  {content}
                </Link>
              );
            })}
          </div>
        </nav>
      ) : null}
    </>
  );
};

export default BottomNavBar;
